<template>
  <v-dialog v-model="dialog" persistent width="700" scrollable>
    <v-card>
      <v-card-title>
        Questionário {{ form.participant.contact.name }}
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon class="ml-3">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="max-height: 80dvh" class="pt-4">
        <v-alert v-if="!form.is_finished" type="warning" text outlined>
          Questionário em curso
        </v-alert>
        <v-alert v-else type="success" text outlined>
          Questionário concluído
        </v-alert>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title>
                Questionário
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!integrated"
                  @click="handleClickApplyChanges"
                  color="primary"
                  elevation="0"
                  class="text-capitalize"
                  :disabled="!form.is_finished"
                  :loading="submiting"
                >
                  Integrar
                </v-btn>
                <v-btn
                  color="primary"
                  elevation="0"
                  class="text-capitalize"
                  disabled
                  v-else
                >
                  Integrado!
                </v-btn>
              </v-card-title>
              <v-card-subtitle>
                Informações preenchidas pelo lesado.
              </v-card-subtitle>

              <v-simple-table dense>
                <tbody>
                  <tr style="background-color: #f1f1f1">
                    <th colspan="2" class="text-center text-subtitle-2">
                      Sinistro
                    </th>
                  </tr>
                  <tr>
                    <th class="text-right" width="40%">Data do sinistro</th>
                    <td>{{ formatDate(form.sinister_date) }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Descrição do sinistro</th>
                    <td>{{ form.sinister_description || "---" }}</td>
                  </tr>
                  <tr style="background-color: #f1f1f1">
                    <th colspan="2" class="text-center text-subtitle-2">
                      Segurado
                    </th>
                  </tr>
                  <tr>
                    <th class="text-right">Nome</th>
                    <td>{{ form.participant?.contact?.name || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">NIF</th>
                    <td>
                      {{ form.nif || "---" }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-right">Email</th>
                    <td>{{ form.email || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Contacto Telefónico</th>
                    <td>{{ form.phone || "---" }}</td>
                  </tr>
                  <tr style="background-color: #f1f1f1">
                    <th colspan="2" class="text-center text-subtitle-2">
                      Local de Risco
                    </th>
                  </tr>
                  <tr>
                    <th class="text-right">Código Postal</th>
                    <td>{{ form.risk_location_postal_code || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Morada</th>
                    <td>{{ form.risk_location_address || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">
                      Os danos causados pelo sinistro impedem a utilização
                      normal da sua habitação?
                    </th>
                    <td>{{ form.remains_in_residence_text || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">
                      O telhado ou cobertura da sua habitação foi afetado pelo
                      sinistro?
                    </th>
                    <td>{{ form.roof_damage_text || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">
                      Existe entrada de água no interior da sua habitação?
                    </th>
                    <td>{{ form.water_inlet_text || "---" }}</td>
                  </tr>
                  <tr style="background-color: #f1f1f1">
                    <th colspan="2" class="text-center text-subtitle-2">
                      Danos
                    </th>
                  </tr>
                  <tr>
                    <td colspan="2" class="font-italic text-center">
                      Fotografias encontram-se na gestão documental
                    </td>
                  </tr>
                  <tr>
                    <th class="text-right">
                      Existem mais danos que queira reportar?
                    </th>
                    <td>{{ form.damage_description || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Fotografias</th>
                    <td>{{ form.files.image.length }}/5</td>
                  </tr>
                  <tr style="background-color: #f1f1f1">
                    <th colspan="2" class="text-center text-subtitle-2">
                      Documentação
                    </th>
                  </tr>
                  <tr>
                    <td colspan="2" class="font-italic text-center">
                      Documentação encontra-se na gestão documental
                    </td>
                  </tr>
                  <tr>
                    <th class="text-right">Caderneta Predial</th>
                    <td>
                      {{
                        form.files.property_tax_registration_document.length
                      }}/1
                    </td>
                  </tr>
                  <tr>
                    <th class="text-right">Relatórios Técnicos</th>
                    <td>{{ form.files.report.length }}/5</td>
                  </tr>
                  <tr>
                    <th class="text-right">Orçamentos</th>
                    <td>{{ form.files.budget.length }}/5</td>
                  </tr>
                  <tr>
                    <th class="text-right">Faturas</th>
                    <td>{{ form.files.invoice.length }}/5</td>
                  </tr>
                  <tr>
                    <th class="text-right">Comprovativo bancário (IBAN)</th>
                    <td>{{ form.files.iban.length }}/1</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title> Detalhes </v-card-title>

              <v-simple-table dense>
                <tbody>
                  <tr>
                    <th class="text-right" width="40%">Participante</th>
                    <td>{{ form.participant.contact.name }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Responsável</th>
                    <td>
                      {{
                        !form.user
                          ? "---"
                          : form.user.name + ` (${form.user.email})`
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="text-right">Data geração</th>
                    <td>{{ formatDateTime(form.created_at) }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Data finalização</th>
                    <td>{{ formatDateTime(form.finished_at) || "---" }}</td>
                  </tr>
                  <tr>
                    <th class="text-right">Data expiração</th>
                    <td>{{ formatDateTime(form.expires_at) || "---" }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDateTime, formatDate } from "@/tools/date";
import { applyFnolChanges } from "@/services/simple_fnol_managers";
import ToastsMixin from "@/mixins/ToastsMixin";

export default {
  mixins: [ToastsMixin],

  components: {},

  props: {},

  data() {
    return {
      dialog: false,
      form: null,
      formatDateTime,
      formatDate,
      submiting: false,
      integrated: false,
    };
  },

  methods: {
    open(form) {
      this.form = { ...form };
      this.dialog = true;
      this.integrated = false;
    },

    close() {
      this.dialog = false;
    },

    async handleClickApplyChanges() {
      this.submiting = true;
      try {
        await applyFnolChanges(this.form.id);
        this.$store.dispatch("refreshLead");
        this.toast("Integração bem sucedida");
        this.integrated = true;
      } catch (error) {
        console.error(error);
        this.toastError("Falha ao integrar");
      } finally {
        this.submiting = false;
      }
    },
  },

  computed: {},
};
</script>
